import { createTheme } from "@mui/material/styles";

import { muiThemePalette } from "./colors";
import { muiThemeComponents } from "./components";
import { muiThemeTypography } from "./typography";

export const berlinTheme = createTheme({
  typography: muiThemeTypography,
  palette: muiThemePalette,
  components: muiThemeComponents,
  breakpoints: {
    values: {
      // these are the default breakpoints from MUI
      // Use useIsMobile, useIsTablet, useIsDesktop to implement responsive design
      xs: 0,
      sm: 400,
      md: 640,
      lg: 1024,
      xl: 1400,
    },
  },
  // Custom spacing scale aligned with Berlin design system
  // spacing(0)=0px, spacing(1)=2px, spacing(2)=5px, spacing(3)=10px, etc.
  spacing: [0, 2, 5, 10, 15, 20, 30, 40, 80],
  borderRadius: {
    xSmall: "3px",
    small: "6px",
    medium: "8px",
    large: "12px",
    xLarge: "16px",
    xxLarge: "30px",
    xxxLarge: "40px",
  },
  size: {
    button: {
      small: {
        height: "1.5rem", // 24px
        iconSize: "0.875rem", // 14px
        paddingX: "10px",
        paddingY: "5px",
      },
      medium: {
        height: "2.375rem", // 38px
        iconSize: "1rem", // 16px
        paddingX: "15px",
        paddingY: "10px",
      },
      large: {
        height: "3.375rem", // 54px
        iconSize: "1.5rem", // 24px
        paddingX: "15px",
        paddingY: "15px",
      },
    },
    icon: {
      small: "0.75rem", // 12px
      medium: "0.875rem", // 14px
      large: "1.125rem", // 18px
      xLarge: "1.5rem", // 24px
    },
    avatar: {
      medium: {
        size: "1.875rem", // 30px
        outlineSize: "2px",
      },
      large: {
        size: "5.625rem", // 90px
        outlineSize: "3px",
      },
    },
    tabs: {
      indicatorHeight: "3px",
      normalHeight: "2.375rem", // 38px
      largeHeight: "2.625rem", // 42px
    },
    segmentedStatusBar: {
      height: "0.625rem", // 10px
      width: "0.125rem", // 2px
    },
    drawer: {
      maxWidth: "25rem", // 400px
    },
    floatingNavigation: {
      height: "3.375rem", // 54px
      margin: "15px",
    },
  },
  borderWidth: {
    regular: "1px",
    thick: "2px",
  },
  opacity: {
    disabled: 0.6,
    floatingNavigation: {
      default: 0.6,
      selected: 0.9,
    },
  },
});
